import React, { useContext } from 'react';
import styled from 'styled-components';

import Header from '../components/Header';
import Reboot from '../style/reboot';
import Global from '../style/global';
import ModalContext from '../store/modalContext';
import Modals from '../modals';
import { colors } from '../consts/style';
import { layoutTypes } from '../types/propTypes';
import Helmet from 'react-helmet';
import Socials from '../components/Socials';

const SiteWrapper = styled.div`
  background: ${colors.light};
`;

const Layout = ({ children, location }) => {
  const { open } = useContext(ModalContext);

  function renderModal() {
    if (!open) return null;
    const ModalComponent = Modals[open];
    return <ModalComponent />;
  }
  return (
    <SiteWrapper>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v5.0.13/css/all.css"
          integrity="sha384-DNOHZ68U8hZfKXOrtjWvjxusGo9WQnrNx2sqG0tfsghAvtVlRW3tvkXWZh58N9jp"
          crossOrigin="anonymous"
        />
      </Helmet>
      <Reboot />
      <Global />
      <Header location={location} />
      <Socials />
      {children}
      {renderModal()}
    </SiteWrapper>
  );
};

Layout.propTypes = layoutTypes;

export default Layout;
